import {
  AdMob,
  InterstitialAdPluginEvents,
  RewardAdPluginEvents,
  MaxAdContentRating,
} from "@capacitor-community/admob";
import { throwErrorWithStack } from "../crashlytics";
import adManager from ".";
import { IS_IOS, IS_TOP, IS_WEB, NUM_LIVES_EARN } from "../config";
import { handlePromises, setTimeoutAsync } from "../promise";
import { getLogger } from "../logging";

const log = getLogger("📺 AdMob");

if (!IS_TOP && !IS_WEB) throw new Error("Not in top window");


const eventCallback =
  (evt, logEvent, incrementLives, showSuccessSnackbar) =>
  (...args) => {
    if (__DEV__) log.debug(evt, JSON.stringify(args));
    logEvent(evt);
    if (evt == "onRewardedVideoAdReward") {
      incrementLives(NUM_LIVES_EARN);
      showSuccessSnackbar(
        NUM_LIVES_EARN == 1
          ? "You earned an extra life!"
          : `You earned ${NUM_LIVES_EARN} extra lives!`
      );
    }
  };

const addEventListeners = (
  eventTypes,
  logEvent,
  incrementLives,
  showSuccessSnackbar
) =>
  Object.values(eventTypes).forEach((evt) =>
    AdMob.addListener(
      evt,
      eventCallback(evt, logEvent, incrementLives, showSuccessSnackbar)
    )
  );

const prepareWithDelay = (prepareFunc) => setTimeoutAsync(prepareFunc, 200);

export const initializeAds = async (store, logEvent, incrementLives, showSuccessSnackbar) => {
  try {
    if (IS_IOS) {
      const { status } = await AdMob.trackingAuthorizationStatus();
      log.info(status);
      // Handle status if needed
    }

    await AdMob.initialize({
      testingDevices: [
        "18f067b7-a386-44bf-9d9a-9469295db7a0",
        "37f70ab8-3ae1-48d5-bd65-f9b9e80cd0fa",
      ],
      initializeForTesting: true,
      maxAdContentRating: MaxAdContentRating.Teen,
      tagForUnderAgeOfConsent: true,
    });
    [InterstitialAdPluginEvents, RewardAdPluginEvents].forEach((eventTypes) =>
      addEventListeners(eventTypes, logEvent, incrementLives, showSuccessSnackbar)
    );
    await handlePromises([
      store.removedAds ||
        prepareWithDelay(() => adManager.prepareAd(AdMob, "Interstitial")),
      prepareWithDelay(() => adManager.prepareAd(AdMob, "Reward")),
    ]);

    // log.debug("AdMob initialized");
  } catch (error) {
    const errorMessages = error.originalErrors
      ? error.originalErrors.map((error) => error.message)
      : [error.message];
    if (errorMessages.every((msg) => msg === "No fill.")) {
      log.error(error.message);
      return;
    }
    throwErrorWithStack(error);
  }
};

// if (__IFRAME__) initializeAds(store);
